import React from 'react'

const HeaderMenu: React.FC = () => {
  return (
    <div className='glass-bg flex flex-col justify-center items-center h-auto w-auto px-12 py-6 rounded-[30px] stag_profile'>   
      <h3 className='text-white text-2xl font-black font-avenir'>VENCLYXTO-based regimens are a foundation of treatment across CLL patient types<sup>1</sup></h3>
      <p className='text-[#ffce0e] text-xl font-normal font-avenir'>Tap the screen to select a patient and learn more about how VENCLYXTO Powers Every Path.<sup>1</sup></p>
    </div>
  )
}

export default HeaderMenu;